import PropTypes from "prop-types";
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Stack,
} from "@mui/material";
import moment from "moment";
import PoTableHead from "./PoTableHead.jsx";

const PoTable = ({
  filteredData,
  order,
  orderBy,
  getComparator,
  stableSort,
  page,
  rowsPerPage,
  handleRequestSort,
  isSmDown,
}) => {
  return (
    <TableContainer>
      <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size="medium">
        <PoTableHead
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          rowCount={filteredData?.length}
        />
        <TableBody>
          {filteredData?.length > 0 &&
            stableSort(filteredData, getComparator(order, orderBy))
              .slice(
                (page - 1) * rowsPerPage,
                (page - 1) * rowsPerPage + rowsPerPage
              )
              .map((row, index) => {
                return (
                  <TableRow hover tabIndex={-1} key={row._id}>
                    <TableCell sx={{ padding: "6px" }} />
                    {/* <TableCell
                      title={row?.Material}
                      sx={{
                        padding: "6px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: 150,
                      }}
                    >
                      {row?.Material}
                    </TableCell> */}
                    <TableCell
                      align="left"
                      title={row?.Mat_Desc}
                      sx={{
                        padding: "6px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: 150,
                      }}
                    >
                      {row?.Mat_Desc}
                    </TableCell>
                    {/* <TableCell
                      align="left"
                      title={row?.Plant}
                      sx={{
                        padding: "6px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: 150,
                      }}
                    >
                      {row?.Plant}
                    </TableCell> */}
                    <TableCell
                      align="left"
                      title={row?.PO_Item_No}
                      sx={{
                        padding: "6px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: 150,
                      }}
                    >
                      {row?.PO_Item_No}
                    </TableCell>
                    <TableCell
                      align="left"
                      title={
                        row?.PO_Date === null
                          ? ""
                          : moment(row?.PO_Date).format("DD/MM/YYYY")
                      }
                    >
                      {row?.PO_Date === null
                        ? ""
                        : moment(row?.PO_Date).format("DD/MM/YYYY")}{" "}
                    </TableCell>
                    {/* <TableCell
                      align="left"
                      title={row?.GR_No}
                      sx={{
                        padding: "6px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: 150,
                      }}
                    >
                      {row?.GR_No}
                    </TableCell> */}
                    {/* <TableCell
                      align="left"
                      title={
                        row?.GR_Date === null
                          ? ""
                          : moment(row?.GR_Date).format("DD/MM/YYYY")
                      }
                    >
                      {row?.GR_Date === null
                        ? ""
                        : moment(row?.GR_Date).format("DD/MM/YYYY")}{" "}
                    </TableCell> */}
                    {/* <TableCell
                      align="left"
                      title={row?.IR_No}
                      sx={{
                        padding: "6px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: 150,
                      }}
                    >
                      {row?.IR_No}
                    </TableCell> */}
                    {/* <TableCell
                      align="left"
                      title={row?.Inspec_No}
                      sx={{
                        padding: "6px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: 150,
                      }}
                    >
                      {row?.Inspec_No}
                    </TableCell> */}
                    {/* <TableCell
                      align="left"
                      title={
                        row?.Inspec_Date === null
                          ? ""
                          : moment(row?.Inspec_Date).format("DD/MM/YYYY")
                      }
                    >
                      {row?.Inspec_Date === null
                        ? ""
                        : moment(row?.Inspec_Date).format("DD/MM/YYYY")}{" "}
                    </TableCell> */}
                    {/* <TableCell
                      align="left"
                      title={row?.Inspec_Qty}
                      sx={{
                        padding: "6px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: 150,
                      }}
                    >
                      {row?.Inspec_Qty}
                    </TableCell> */}
                    <TableCell
                      align="left"
                      title={
                        row?.Invoice_Date === null
                          ? ""
                          : moment(row?.Invoice_Date).format("DD/MM/YYYY")
                      }
                    >
                      {row?.Invoice_Date === null
                        ? ""
                        : moment(row?.Invoice_Date).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell
                      align="left"
                      title={row?.Pay_Doc}
                      sx={{
                        padding: "6px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: 150,
                      }}
                    >
                      {row?.Pay_Doc}
                    </TableCell>
                    <TableCell
                      align="left"
                      title={
                        row?.UTR_Date === null
                          ? ""
                          : moment(row?.UTR_Date).format("DD/MM/YYYY")
                      }
                    >
                      {row?.UTR_Date === null
                        ? ""
                        : moment(row?.UTR_Date).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell
                      align="left"
                      title={row?.UTR_No}
                      sx={{
                        padding: "6px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: 150,
                      }}
                    >
                      {row?.UTR_No}
                    </TableCell>
                    <TableCell
                      align="left"
                      title={row?.UTR_Amount}
                      sx={{
                        padding: "6px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: 150,
                      }}
                    >
                      {row?.UTR_Amount}
                    </TableCell>
                  </TableRow>
                );
              })}
        </TableBody>
      </Table>
      {(filteredData?.length <= 0 || filteredData?.length === undefined) && (
        <Stack
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <img
            src="/assets/images/no-data.avif"
            alt="No data Available"
            style={{
              width: isSmDown ? "359px" : "400px",
              height: isSmDown ? "379px" : "400px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          ></img>
        </Stack>
      )}
    </TableContainer>
  );
};

PoTable.propTypes = {
  filteredData: PropTypes.shape({
    length: PropTypes.number,
  }),
  getComparator: PropTypes.func,
  handleRequestSort: PropTypes.any,
  isSmDown: PropTypes.any,
  order: PropTypes.any,
  orderBy: PropTypes.any,
  page: PropTypes.number,
  rowsPerPage: PropTypes.any,
  stableSort: PropTypes.func,
};

export default PoTable;
